
  import { computed, defineComponent, onMounted, onUnmounted, ref, toRefs } from 'vue';
  import BaseIcon from '../../BaseIcon/src/BaseIcon.vue';

  export default defineComponent({
    name: 'BaseBackTop',
    components: { BaseIcon },
    props: {
      el: {
        type: String,
        default: '',
      },
      offset: {
        type: Number,
        default: 300,
      },
      right: {
        type: Number,
        default: 10,
      },
      bottom: {
        type: Number,
        default: 50,
      },
    },
    setup(props) {
      const { el, offset } = toRefs(props);
      const scorllTop = ref(0);
      let dom;

      onMounted(() => {
        dom = document.querySelector(el.value) as HTMLElement;
        if (dom) {
          dom.addEventListener('scroll', onScroll);
        }
      });
      function onScroll() {
        if (dom) {
          scorllTop.value = dom.scrollTop;
        }
      }

      onUnmounted(() => {
        if (dom) {
          dom.removeEventListener('scroll', onScroll);
        }
      });

      function backTop() {
        if (dom) {
          dom.scrollTop = 0;
        }
      }

      const visible = computed(() => scorllTop.value >= offset.value);

      return {
        visible,
        backTop,
      };
    },
  });
